import { useMemo, type ReactNode } from 'react';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { createAppTheme } from './appTheme';

/**
 * Mantém ThemeProvider só para superfícies ainda em MUI (DataGrid).
 * A identidade visual da aplicação vem do design system via CSS/Tailwind.
 */
export function AppThemeProvider({ children }: { children: ReactNode }) {
  const theme = useMemo(() => createAppTheme(), []);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
}
